module.exports = __webpack_public_path__ + "media/images/jamicons/shield-check-f-5090b82fa43d574bfa34e2a90a0b6697.svg";